import swal, { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';
import { injectable, inject } from 'inversify';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { IModalManagerService } from '@/app-modules/modal-manager/modal-manager-service';
import { ModalManagerPlugin } from '@/plugins/modal-manager';
import { UserPreferences } from '@/app-modules/store/modules/user-preferences';
import { container } from '@/app-modules/_ioc';
import { IPersistedStore } from '@/app-modules/store/persisted-store';

interface ISweetAlertService {
  show(options: SweetAlertOptions, refocus?: boolean): Promise<SweetAlertResult>;
  enqueue(options: SweetAlertOptions, refocus?: boolean): Promise<any>;
}

@injectable()
class SweetAlertService implements ISweetAlertService {
  private persistedStore = container.get(SERVICE_IDENTIFIERS.IPersistedStore) as IPersistedStore;
  private userPreferences: UserPreferences = this.persistedStore.Get(UserPreferences);

  constructor(@inject(SERVICE_IDENTIFIERS.IModalManagerService) private readonly modalManagerService: IModalManagerService) {

  }

  private get modalManager(): ModalManagerPlugin {
    return this.modalManagerService.getModalManager();
  }

  public show(options: SweetAlertOptions, refocus?: boolean): Promise<SweetAlertResult> {
    if (refocus) {
      options.onAfterClose = () => {
        this.modalManager.refocusLastModal();
      };
    }

    return swal(options);
  }
  public enqueue(options: SweetAlertOptions, refocus?: boolean): Promise<any> {
    options.position = this.determineNotificationPosition();

    if (refocus) {
      options.onAfterClose = () => {
        this.modalManager.refocusLastModal();
      };
    }

    if (!swal.isVisible()) {
      return swal.queue([options]);
    }

    swal.insertQueueStep(options);
    return Promise.resolve();
  }

  private determineNotificationPosition() {
    // if a user has default settings, use the default top-right setting
    if (!this.userPreferences.notificationPosition) {
      return 'top-right';
    }
    else {
      return this.userPreferences.notificationPosition.toString() as any;
    }
  }
}

export { ISweetAlertService, SweetAlertService };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/sweet-alert-service/sweet-alert-service.ts